// extracted by mini-css-extract-plugin
export default {"app":"App_app__GuJBs","terms":"App_terms__byWC5","head":"App_head__O+m7u","title":"App_title__wJw7v"};